module.exports = __webpack_public_path__ + "img/icon-cancel.d40b7dd6.svg";